import React from 'react';
import { renderRichText } from '@vhub/gatsby-source-contentful/rich-text';
import options from '../../../../helpers/ContentFulOptions';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { css } from 'styled-components';
import { SectionFeatureCardsContent } from './types/SectionFeatureCards.types';

const CONTENTFUL_SECTION_ELEMENT_FEATURE_IMAGE =
  'ContentfulSectionElementFeatureImage';
const CONTENTFUL_SECTION_ELEMENT_FEATURE_VIDEO =
  'ContentfulSectionElementFeatureVideo';
const CONTENTFUL_SECTION_ELEMENT_RICH_TEXT = 'ContentfulSectionElementRichText';

const assetContainer = css`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;

  @media only screen and (min-width: 1020px) {
    min-height: 320px;
  }

  @media only screen and (max-width: 1072px) and (min-width: 1025px) {
    min-height: 342px;
  }

  @media only screen and (max-width: 1024px) {
    margin-bottom: 24px;
  }
`;

const videoiframe = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const featureTextCard = css`
  margin: 3em;
  .heading {
    margin-top: 8px;
  }
`;

interface SectionFeatureCardsProps {
  content: SectionFeatureCardsContent;
}

const SectionFeatureCards: React.FC<SectionFeatureCardsProps> = ({
  content,
}) => {
  switch (content.__typename) {
    case CONTENTFUL_SECTION_ELEMENT_FEATURE_IMAGE:
      return (
        <GatsbyImage
          image={getImage(content.mainImage)!}
          css={assetContainer}
          alt={content.mainImage.description}
        />
      );

    case CONTENTFUL_SECTION_ELEMENT_FEATURE_VIDEO:
      return (
        <div css={assetContainer}>
          <iframe
            css={videoiframe}
            id="ytplayer"
            src={`https://www.youtube.com/embed/${content.url}`}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            type="text/html"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          />
        </div>
      );

    case CONTENTFUL_SECTION_ELEMENT_RICH_TEXT:
      return (
        <div css={featureTextCard}>
          {renderRichText(content.text, options)}
        </div>
      );
    default:
      return null;
  }
};

SectionFeatureCards.propTypes = {
  // TODO:
};

export default SectionFeatureCards;
